/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
document.addEventListener('DOMContentLoaded', function() {
  const infoWrapper = document.querySelector('.Product__InfoWrapper');

  if (!infoWrapper) return;

  function fixInfoHeight() {
    // Evita que el tema meta max-height exagerado
    infoWrapper.style.maxHeight = 'none';
    infoWrapper.style.height = 'auto';
  }

  // Ejecutar al cargar
  fixInfoHeight();

  // Ejecutar después de cualquier reflow del tema (cambios dinámicos)
  setTimeout(fixInfoHeight, 50);
  setTimeout(fixInfoHeight, 200);
  setTimeout(fixInfoHeight, 500);

  // Ejecutar cuando se cambia variante
  document.addEventListener('variant:change', fixInfoHeight);

  // Recalcular con resize
  window.addEventListener('resize', fixInfoHeight);
});